import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=8e0833ca&scoped=true"
import script from "./TheFooter.js?vue&type=script&lang=js&external"
export * from "./TheFooter.js?vue&type=script&lang=js&external"
import style0 from "./TheFooter.scss?vue&type=style&index=0&id=8e0833ca&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0833ca",
  null
  
)

export default component.exports